export const NUMBER_OF_STARS = 5;
